import { $t } from '@/i18n';
/* eslint-disable import/no-webpack-loader-syntax */
import { memoize } from 'lodash';
import { getAIPageContextInstance } from '@/utils/global/api';
import { globalConstantService } from '@/workbench/modules/services/global-constant';
import { getDataSchemaType } from '@utils/data-schema-helper';
import { getGlobalConstantSchema } from '@/utils/global/api-schema';
import { MessagePlugin, DialogPlugin } from 'tdesign-vue';
import dts from '!!raw-loader!./wuji.d.ts';
export async function getTypeDefinitions(projectId) {
    const globalDTS = await getGlobalConstantTypeDefinitions(projectId);
    if (!globalDTS) {
        const mergedDts = dts.replace('/** inject-global-constant-dts */', '');
        console.log(mergedDts);
        return mergedDts;
    }
    const mergedDts = dts.replace('/** inject-global-constant-dts */', $t(`k_7f2db976`, { arg_0: globalDTS }));
    console.log(mergedDts);
    return mergedDts;
}
export const getGlobalConstantTypeDefinitions = memoize(async (projectId) => {
    if (window.w?.mode !== 'editor' || !projectId)
        return '';
    const constList = await globalConstantService.list(projectId);
    const frontConstantList = constList.filter(item => !item.onlyBackend);
    if (!frontConstantList.length)
        return '';
    const schema = getGlobalConstantSchema(frontConstantList);
    const dts = getDataSchemaType(schema, { dept: 1, forceFieldsRequired: true });
    return dts.trim();
});
export default class Wuji {
    getCurrentUser = () => {
        const w = getAIPageContextInstance();
        return {
            ...w.user,
            hasPermission: (permission) => w.hasPermission(permission),
            isRoleMemberOf: (role) => w.isRoleMemberOf(role),
        };
    };
    getGlobal = () => {
        const w = getAIPageContextInstance();
        return w.global;
    };
    get Sidebar() {
        const w = getAIPageContextInstance();
        return w.sidebar;
    }
    get ai() {
        const w = getAIPageContextInstance();
        return w.ai;
    }
    get Message() {
        return MessagePlugin;
    }
    get Confirm() {
        return DialogPlugin.confirm;
    }
    // 支持 import wuji from '@wujibase/wuji' 的形式
    get default() {
        return this;
    }
}
